import Table from 'react-bootstrap/Table';
import { useEffect, useState, useRef, useCallback } from 'react';
import SaveTable from '../../images/saveTable.png'
import { Fragment } from 'react';
import _ from 'lodash';
import instance from '../../services/baseService'
import { ROUTES } from '../../constants/file-uploads'

export default function EgmTable(props) {

  const { headers, data, handleSubmitFunc } = props
  const [tableData, setTableData] = useState({});
  const stateData = useRef(tableData)
  const processingRef = useRef(new Set()) // Track processing requests
  const timeoutRef = useRef(null) // For debouncing

  const setRefData = data => {
    stateData.current = data
    setTableData(data)
  }

  // Debounced handler to prevent multiple calls
  const debouncedHandler = useCallback(
    _.debounce(async (eventDetail) => {
      const { ibill, icode, idate } = eventDetail;
      
      // Create a unique key for this update
      const updateKey = `${ibill}-${icode}-${idate}`;
      
      // Prevent duplicate processing
      if (processingRef.current.has(updateKey)) {
        console.log("Already processing this update, skipping...");
        return;
      }

      processingRef.current.add(updateKey);

      try {
        let obj = stateData.current[ibill];
        if (!obj) {
          console.warn("Object not found for ibill:", ibill);
          return false;
        }

        obj = { ...obj, egm_number: icode, egm_date: idate };
        
        // Only make API call if we have required data
        if (obj.id && obj.folder) {
          const data = { egm_number: icode, egm_date: idate };
          const response = await instance.post(
            ROUTES.EGM_UPDATE(obj.id, obj.folder),
            data
          );
        } else {
          console.warn("Missing id or folder, skipping API call");
        }
        
      } catch (error) {
        console.error("Error saving:", error);
        return false;
      } finally {
        // Remove from processing set after a delay
        setTimeout(() => {
          processingRef.current.delete(updateKey);
        }, 1000);
      }
    }, 300), // 300ms debounce delay
    []
  );

  // Stable event handler using useCallback
  const handleCustomEvent = useCallback(async (e) => {
    debouncedHandler(e.detail);
  }, [debouncedHandler]);

  useEffect(() => {
    const obj = _.keyBy(data, 'id')
    setRefData(obj)
    
    document.addEventListener('egmUpdateTrigger', handleCustomEvent)
    
    return () => {
      document.removeEventListener('egmUpdateTrigger', handleCustomEvent)
      debouncedHandler.cancel()
      processingRef.current.clear()
    }
  }, [data, handleCustomEvent, debouncedHandler])

  const handleUpdate = (id, key, value) => {
    let obj = { ...tableData };
    obj[id] = { ...obj[id], [key]: value };
    setRefData(obj);
  }

  const handleSubmit = (id) => {
    if (typeof handleSubmitFunc === 'function') {
      handleSubmitFunc(tableData[id]);
    }
  }

  return (
    <div className='mb-2' style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
      <Table
        responsive
        size="sm"
        className='v-height v-egm'>
        <thead>
          <tr>
            <th>Action</th>
            {Array.isArray(headers) && headers.map((header, index) => {
              return <th key={`header-${index}`} scope="col">{header.name}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(Object.values(tableData)) && Object.values(tableData).map((ind_data) => {
            return (
              <tr key={`row-${ind_data.id}`}>
                <td className='p-3' >
                  <img 
                    onClick={() => handleSubmit(ind_data.id)} 
                    className='w-10 cursor-pointer' 
                    id={`save_${ind_data.id}`} 
                    src={SaveTable} 
                    alt="Save"
                  />
                </td>
                {Array.isArray(headers) && headers.map((header, headerIndex) => {
                  const tdprops = {}
                  const inputprops = {}

                  if (!header.field) {
                    tdprops['id'] = `${header.key}${ind_data.id}`
                  } else {
                    inputprops['id'] = `${header.key}${ind_data.id}`
                  }

                  return (
                    <Fragment key={`cell-${ind_data.id}-${headerIndex}`}>
                      <td {...tdprops} > 
                        {'invoice_number' == header.id && (
                          <input 
                            type="hidden" 
                            id={`id_${ind_data.id}`} 
                            value={ind_data.id} 
                          />
                        )}

                        {!header.field && (
                          `${(!!header.modifier ? header.modifier(ind_data[header.id]) : ind_data[header.id])} ${(!!header.suffix ? header.suffix : '')}`
                        )}
                        {
                          header.field && (
                            <input  
                              {...inputprops} 
                              type="text" 
                              placeholder='Enter the value' 
                              onChange={(e) => handleUpdate(ind_data.id, header.id, e.target.value)} 
                              value={ind_data[header.id] ? ind_data[header.id] : ''} 
                            />
                          )
                        }
                      </td>
                    </Fragment>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}